import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CallbackComponent } from './callback.component';

/**
 * Routes for Auth0 callbacks
 * @type {[{path: string; component: CallbackComponent}]}
 */
const callbackRoutes: Routes = [
  { path: 'callback', component: CallbackComponent }
];

/**
 * Router module for CallbackModule
 */
@NgModule({
  imports: [
    RouterModule.forChild(callbackRoutes)
  ],
  exports: [RouterModule]
})
export class CallbackRoutingModule {
}
